/**
 * Cache utilities for API responses
 */

export const ThirtyMinutesTTL = 30 * 60 * 1000; // 30 minutes in milliseconds

interface CacheItem<T> {
  data: T;
  timestamp: number;
  ttl: number;
}

const cache = new Map<string, CacheItem<any>>();

/**
 * Fetch data with caching support
 */
export const fetchWithCache = async <T>(
  key: string,
  fetcher: () => Promise<T>,
  ttl: number = ThirtyMinutesTTL,
): Promise<T> => {
  const now = Date.now();
  const cached = cache.get(key);

  // Check if cache is valid
  if (cached && now - cached.timestamp < cached.ttl) {
    return cached.data;
  }

  // Fetch new data
  const data = await fetcher();

  // Store in cache
  cache.set(key, {
    data,
    timestamp: now,
    ttl,
  });

  return data;
};

/**
 * Clear cache by key
 */
export const clearCache = (key: string): void => {
  cache.delete(key);
};

/**
 * Clear all cache
 */
export const clearAllCache = (): void => {
  cache.clear();
};
